(function () {
  if (window.KSVideoSlider) return;

  var VIDEO_ID = /^[\w-]{6,20}$/;

  function init(root) {
    if (!root || root.getAttribute('data-ready') === 'true') return;

    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var caption = root.querySelector('[data-caption]');
    var viewport = root.querySelector('.ks-video-slider__viewport');

    if (!track || !slides.length) return;

    root.setAttribute('data-ready', 'true');

    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6) * 1000;
    var timer = null;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    if (window.Shopify && window.Shopify.designMode) autoplay = false;

    function syncSlides() {
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
    }

    function setCaption(slide) {
      if (!caption) return;
      var title = slide.getAttribute('data-title') || '';
      caption.textContent = title;
      caption.hidden = title === '';
    }

    function stopVideo(slide) {
      var player = slide.querySelector('[data-player]');
      if (player) player.innerHTML = '';
      slide.classList.remove('is-playing');
    }

    function play(slide) {
      var id = slide.getAttribute('data-video-id') || '';
      if (!VIDEO_ID.test(id) || slide.classList.contains('is-playing')) return;

      slides.forEach(stopVideo);
      stopAutoplay();

      var player = slide.querySelector('[data-player]');
      if (!player) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'ks-video-slider__iframe';
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title = slide.getAttribute('data-title') || 'YouTube video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      player.appendChild(iframe);
      slide.classList.add('is-playing');
    }

    function applyRatio(slide) {
      var ratio = slide && slide.getAttribute('data-ratio');
      if (!ratio || !viewport) return;
      viewport.style.setProperty('--ks-ratio', ratio);
    }

    function go(next) {
      if (!slides.length) return;
      next = ((next % slides.length) + slides.length) % slides.length;
      if (next === index) return;

      stopVideo(slides[index]);
      index = next;
      track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';

      syncSlides();

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      setCaption(slides[index]);
      applyRatio(slides[index]);

      if (!slides[index].classList.contains('is-playing')) startAutoplay();
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(function () {
        if (slides[index].classList.contains('is-playing')) return;
        go(index + 1);
      }, speed);
    }

    root.addEventListener('click', function (event) {
      var playButton = event.target.closest('[data-play]');
      var dot = event.target.closest('[data-dot]');
      var prev = event.target.closest('[data-prev]');
      var next = event.target.closest('[data-next]');

      if (playButton && root.contains(playButton)) {
        var slide = playButton.closest('[data-slide]');
        if (slide) play(slide);
      }

      if (dot && root.contains(dot)) {
        go(parseInt(dot.getAttribute('data-index'), 10));
        stopAutoplay();
      }

      if (prev && root.contains(prev)) {
        go(index - 1);
        stopAutoplay();
      }

      if (next && root.contains(next)) {
        go(index + 1);
        stopAutoplay();
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(index + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index - 1);
      }
    });

    if (viewport) {
      viewport.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-play], .ks-video-slider__arrow')) return;
        tracking = true;
        startX = event.clientX;
        startY = event.clientY;
      });

      viewport.addEventListener('pointerup', function (event) {
        if (!tracking) return;
        tracking = false;
        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        go(deltaX < 0 ? index + 1 : index - 1);
        stopAutoplay();
      });

      viewport.addEventListener('pointercancel', function () {
        tracking = false;
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', function () {
      if (!slides[index].classList.contains('is-playing')) startAutoplay();
    });

    syncSlides();
    setCaption(slides[index]);
    applyRatio(slides[index]);
    startAutoplay();

    root._ksSlider = { go: go };
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-ks-video-slider]')) init(context);
    Array.prototype.forEach.call(context.querySelectorAll('[data-ks-video-slider]'), init);
  }

  window.KSVideoSlider = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-slide]');
    if (!slide) return;
    var root = slide.closest('[data-ks-video-slider]');
    if (!root || !root._ksSlider) return;
    root._ksSlider.go(parseInt(slide.getAttribute('data-index'), 10));
  });
})();
